import { DateService, DateTimeLocalizationInfo, DateTimeService, TimeService } from '@mews/framework';

export const existsDateRangeCollision = (dateRange1: $TSFixMe) => (dateRange2: $TSFixMe) => {
    const dateRangeCollision =
        (dateRange1.startDate < dateRange2.endDate && dateRange2.startDate < dateRange1.endDate) ||
        (dateRange1.startDate === dateRange2.startDate && dateRange1.endDate === dateRange2.endDate);
    if (dateRange1.startTime && dateRange1.endTime && dateRange2.startTime && dateRange2.endTime) {
        return (
            dateRangeCollision &&
            ((dateRange1.startTime < dateRange2.endTime && dateRange2.startTime < dateRange1.endTime) ||
                (dateRange1.startTime === dateRange2.startTime && dateRange1.endTime === dateRange2.endTime))
        );
    }
    return dateRangeCollision;
};

export const unitCounter = ({ isDayService, nightCount }: { isDayService: boolean; nightCount: number }) =>
    isDayService ? nightCount + 1 : nightCount;

export const getDateTime = (dateString: string, timeString: string | null, timezone: string) => {
    const date = DateService.parse(dateString, timezone);
    if (timeString) {
        const time = TimeService.parse(timeString);
        return DateTimeService.fromDateAndTime(date, time);
    }
    return DateTimeService.parse(dateString, timezone);
};

export const getSameDayHourBoundary = ({
    isSameDayOrder,
    selectedBoundary,
    initialBoundary,
    localizationInfo,
    hoursToAdjust,
}: {
    isSameDayOrder: boolean;
    selectedBoundary: string;
    initialBoundary: string;
    localizationInfo: DateTimeLocalizationInfo;
    hoursToAdjust?: number;
}): string => {
    if (!isSameDayOrder) return '';

    const isValidSelectedBoundary =
        selectedBoundary && TimeService.isValidShortString(selectedBoundary, localizationInfo);
    const isValidInitialBoundary = initialBoundary && TimeService.isValidShortString(initialBoundary, localizationInfo);

    if (!isValidSelectedBoundary && !isValidInitialBoundary) return '';

    const time = isValidSelectedBoundary ? selectedBoundary : initialBoundary;

    return hoursToAdjust === undefined || hoursToAdjust === 0
        ? time
        : TimeService.toShortString(
              TimeService.addHours(TimeService.fromShortString(time, localizationInfo), hoursToAdjust),
              localizationInfo
          );
};
